import Vue from 'vue'

// Reaktywność: bumpGrowthBook() po zmianie flag → komponenty z growthbookMixin się przerenderują.
const state = Vue.observable({ rev: 0 })

export function bumpGrowthBook () {
  state.rev++
}

export const growthbookMixin = {
  methods: {
    gbValue (key, fallback) {
      // eslint-disable-next-line no-unused-expressions
      state.rev
      return this.$gb ? this.$gb.getFeatureValue(key, fallback) : fallback
    },
    gbOn (key) {
      // eslint-disable-next-line no-unused-expressions
      state.rev
      return this.$gb ? this.$gb.isOn(key) : false
    }
  }
}
